const $ = jQuery.noConflict();

class LogosSlider {
    constructor() {
        this.slider  = $('.university-logos__slider');
        this.slides  = this.slider.find('.slick-slide');

    }
    init() {
        this.initSlider();
    }

    initSlider() {
        this.slider.slick({
            dots: false,
            arrows: false,
            slidesToShow: 4,
            inifinite: true,
            fade: false,
            pauseOnHover: false,
            speed: 600,
            autoplay: true,
            pauseOnFocus: false,
            autoplaySpeed: 4000,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        variableWidth: true,
                        centerMode: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
            ],

        });
    }

    refresh() {
        this.slider.slick('refresh');
    }

}

export default new LogosSlider();
